/**
 * Created by alvinoktavianus on 5/9/17.
 */

import { API_URL } from '../constants'

export const BILLINGS = `${API_URL}/v1/billings`
export const OUTLETS = `${API_URL}/v1/outlets`
export const RULES = `${API_URL}/v1/billings/rules`
export const SUBSCRIPTION_STATUS = `${API_URL}/v1/feature/get_subscription_status`
export const VERIFY_BILLING = `${API_URL}/v1/billings/verify`
export const FEATURE_SUBSCRIPTION_PRICE = `${API_URL}/v1/feature/get_feature_price_per_months`
export const CANCEL_SUBSCRIPTION = `${API_URL}/v1/feature/cancel_subscription`
export const ALL_OUTLETS = `${API_URL}/v1/outlets?with_inactive=true`



// WEBPACK FOOTER //
// ./app/api/billing/constant.js